import { AUTH_USER } from './constants';

export function authUser(data,setLoading, setFalseData) {
  return {
    type: AUTH_USER,
    user: data.username.trim(),
    pass: data.password.trim(),
    setLoading,
    setFalseData
  };
}
